(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracSourceTypeDeleteController',NasracSourceTypeDeleteController);

    NasracSourceTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'NasracSourceType'];

    function NasracSourceTypeDeleteController($uibModalInstance, entity, NasracSourceType) {
        var vm = this;

        vm.nasracSourceType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id, sourceType) {
            NasracSourceType.delete({id: id, sourceType: sourceType},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
